import { e as entry } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';
import __vue_component__$1 from './NewsEntity.js';
import __vue_component__$2 from './EventEntity.js';

//
var script = {
  mixins: [entry],
  computed: {
    entityComponent: function entityComponent() {
      switch (this.entryData.Entity.Class) {
        case 'News':
          return 'news-entity';

        case 'Event':
          return 'event-entity';

        default:
          throw new Error("entity class \"".concat(this.entryData.Entity.Class, "\" is not supported"));
      }
    },
    isOwnPage: function isOwnPage() {
      return this.entryData.Json.EntityPageID === 0;
    }
  },
  components: {
    NewsEntity: __vue_component__$1,
    EventEntity: __vue_component__$2
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "js-entry o-entry c-entity-entry" },
    [
      _c(_vm.entityComponent, {
        tag: "component",
        attrs: { entityData: _vm.entryData.Entity }
      }),
      _vm._v(" "),
      !_vm.isOwnPage
        ? _c(
            "div",
            { staticClass: "c-entity-entry__more-link" },
            [
              _c(
                "router-link",
                { attrs: { to: "/page/" + _vm.entryData.Json.EntityPageID } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("global.more")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=EntityEntry.js.map
